import SoftSignals from './SoftSignals.component';

export default SoftSignals;
